export function uid(): string {
  // crypto.randomUUID is great but TS/DOM libs vary across environments
  const c: any = typeof crypto !== "undefined" ? crypto : null;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

/** RFC 4122 v4 UUID. Unlike uid(), never falls back to a non-UUID string:
 *  crypto.randomUUID only exists in secure contexts (https/localhost), but
 *  getRandomValues works everywhere — including the plain-http test server —
 *  and uuid-typed columns (org_proposal_sections.id) need a real UUID. */
export function uuidV4(): string {
  const c: any = typeof crypto !== "undefined" ? crypto : null;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  const b = new Uint8Array(16);
  if (c && typeof c.getRandomValues === "function") c.getRandomValues(b);
  else for (let i = 0; i < 16; i++) b[i] = Math.floor(Math.random() * 256);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}
